import { CalculationInputs, generateRentalSchedule } from './calculationUtils';

/**
 * Goal Seek utility to find the disbursement amount
 * that makes the last principal outstanding close to zero
 */
export const goalSeek = (inputs: CalculationInputs): number => {
  const tolerance = 0.01;
  const maxIterations = 1000;
  
  let low = 0;
  let high = inputs.totalRental * 100; // Upper bound
  let mid = inputs.totalRental; // Initial guess
  
  for (let i = 0; i < maxIterations; i++) {
    mid = (low + high) / 2;
    
    const testInputs = { ...inputs, disbursementAmount: mid };
    const schedule = generateRentalSchedule(testInputs);
    
    if (schedule.length === 0) return mid;
    
    const lastItem = schedule[schedule.length - 1];
    const outstanding = lastItem.principalOutstanding;
    
    if (Math.abs(outstanding) < tolerance) {
      return mid;
    }
    
    if (outstanding > 0) {
      // Need less disbursement
      high = mid;
    } else {
      // Need more disbursement
      low = mid;
    }
  }
  
  return mid;
};